/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';

import GoogleMap from './GoogleMap';
import GoogleMapSearchBar from './GoogleMapSearchBar';
import { GoogleMapLocationSelectorProps } from './GoogleMapLocationSelector.Model';
import { GoogleMapsLoader } from './GoogleMapsLoader';

const GoogleMapLocationSelector = ({
  currentLocation,
  setCurrentLocation,
  setCurrentAddress,
  zoomValue,
  setIsError,
  showSnackbar,
  addressExists,
  setAddressExists,
  showSearchInput,
}: GoogleMapLocationSelectorProps): JSX.Element => {
  return (
    <>
      <GoogleMapsLoader>
        <GoogleMap
          currentLocation={currentLocation}
          setCurrentLocation={setCurrentLocation}
          setCurrentAddress={setCurrentAddress}
          zoomValue={zoomValue}
          setIsError={setIsError}
          showSnackbar={showSnackbar}
        />
        {showSearchInput !== false && (
          <GoogleMapSearchBar
            currentLocation={currentLocation}
            setCurrentLocation={setCurrentLocation}
            setCurrentAddress={setCurrentAddress}
            addressExists={addressExists}
            setAddressExists={setAddressExists}
          />
        )}
      </GoogleMapsLoader>
    </>
  );
};

export default GoogleMapLocationSelector;
